<template>
  <v-dialog v-model="dialog" :overlay="false" scrollable width="650">
    <v-card tile flat>
      <v-toolbar dark color="primary">
        <v-app-bar-nav-icon><v-icon>person_add</v-icon></v-app-bar-nav-icon>
        <v-toolbar-title v-if="isUpdate"
          >Update referral details for: {{ referralDetails.company_name }}</v-toolbar-title
        >
        <v-toolbar-title v-else>Add new referral</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="closeDialog" dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pa-0" style="height: 100vh">
        <v-stepper vertical v-model="step">
          <v-stepper-step step="1" :complete="step > 1" editable class="ma-0">
            Referral Company Details
          </v-stepper-step>
          <v-stepper-content step="1">
            <v-card flat tile class="ma-0 mb-5">
              <v-card-text class="pa-0">
                <v-form lazy-validation>
                  <v-container fluid grid-list-md class="pa-0">
                    <v-row>
                      <v-col v-if="PlatformUser()">
                        <v-autocomplete
                          :items="RegistrationReferrerList"
                          item-text="name"
                          item-value="id"
                          v-model="businessId"
                          label="Referring partner"
                          hide-details
                        ></v-autocomplete>
                      </v-col>
                      <v-col v-if="PlatformUser()">
                        <v-autocomplete
                          :items="users"
                          item-text="full_name"
                          item-value="id"
                          v-model="updates.creator_id"
                          label="Referring user"
                          hide-details
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          label="Company name"
                          v-model="updates.company_name"
                          required
                          hide-details
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col xs="12" sm="6">
                        <v-select
                          :items="legalStatuses"
                          item-text="name"
                          item-value="id"
                          v-model="updates.legal_status"
                          hide-selected
                          placeholder="Legal status"
                          hide-details
                        ></v-select>
                      </v-col>
                      <v-col>
                        <v-text-field
                          label="Months of revenue"
                          v-model="updates.months_of_revenue"
                          hide-details
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col xs="12" sm="2" md="2">
                        <v-text-field label="Title" v-model="updates.title" hide-details></v-text-field>
                      </v-col>
                      <v-col xs="12" sm="5" md="5">
                        <v-text-field label="First name" v-model="updates.first_name" hide-details></v-text-field>
                      </v-col>
                      <v-col xs="12" sm="5" md="5">
                        <v-text-field label="Last name" v-model="updates.last_name" hide-details></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col xs="12" sm="6">
                        <v-text-field
                          label="Email"
                          v-model="updates.email"
                          :rules="emailRules"
                          required
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col xs="12" sm="6">
                        <v-text-field label="Phone" v-model="updates.phone" required hide-details></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
            </v-card>
            <v-btn color="accent" @click.native="step = 2">Continue</v-btn>
          </v-stepper-content>

          <v-stepper-step step="2" :complete="step > 2" editable>
            Referral address details
          </v-stepper-step>
          <v-stepper-content step="2">
            <v-container fluid grid-list-md class="pa-0 mb-5">
              <v-row>
                <v-col xs="12" sm="6">
                  <v-text-field label="Address Line 1" v-model="updates.address_1" hide-details></v-text-field>
                </v-col>
                <v-col xs="12" sm="6">
                  <v-text-field label="Address Line 2" v-model="updates.address_2" hide-details></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col xs="12" sm="6">
                  <v-text-field label="Address Line 3" v-model="updates.address_3" hide-details></v-text-field>
                </v-col>
                <v-col xs="12" sm="6">
                  <v-text-field label="Address Line 4" v-model="updates.address_4" hide-details></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col xs="12" sm="6">
                  <v-text-field label="Address Line 5" v-model="updates.address_5" hide-details></v-text-field>
                </v-col>
                <v-col xs="12" sm="6">
                  <v-text-field label="Postcode" v-model="updates.post_code" hide-details></v-text-field>
                </v-col>
              </v-row>
            </v-container>
            <v-btn color="accent" @click.native="step = 3">Continue</v-btn>
          </v-stepper-content>

          <v-stepper-step step="3" :complete="step > 3" editable>Referral funding details</v-stepper-step>
          <v-stepper-content step="3">
            <v-row>
              <v-col xs="12" sm="6">
                <v-text-field
                  label="Requested amount"
                  :rules="[v => !isNaN(v) || 'Please enter only numbers']"
                  v-model="updates.requested_amount"
                  prefix="£"
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col xs="12" sm="6">
                <v-select
                  :items="financeTypes"
                  item-text="name"
                  item-value="id"
                  v-model="updates.finance_type_requested"
                  label="Finance Type Requested"
                  hide-details
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col xs="12" sm="6">
                <v-menu
                  ref="requestedOnMenu"
                  :close-on-content-click="false"
                  v-model="pickers.requested_on"
                  transition="scale-transition"
                  offset-y
                  full-width
                  :nudge-right="40"
                  min-width="290px"
                  :return-value.sync="updates.requested_on"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="updates.requested_on"
                      placeholder="Requested on"
                      label="Requested on"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                      hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="updates.requested_on"
                    scrollable
                    locale="en-gb"
                    @change="$refs.requestedOnMenu.save(updates.requested_on)"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="pickers.requested_on = false">Cancel</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col xs="12" sm="6">
                <v-menu
                  ref="requiredByMenu"
                  :close-on-content-click="false"
                  v-model="pickers.required_by"
                  transition="scale-transition"
                  offset-y
                  full-width
                  :nudge-right="40"
                  min-width="290px"
                  :return-value.sync="updates.required_by"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="updates.required_by"
                      placeholder="Required by"
                      label="Required by"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                      hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="updates.required_by"
                    scrollable
                    locale="en-gb"
                    @change="$refs.requiredByMenu.save(updates.required_by)"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="pickers.required_by = false">Cancel</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col xs="12" sm="6">
                <v-text-field label="Referral reference" v-model="updates.bank_reference" hide-details></v-text-field>
              </v-col>
            </v-row>
            <v-btn color="accent" @click.native="step = 4">Continue</v-btn>
          </v-stepper-content>

          <v-stepper-step step="4" :complete="step > 4" editable>
            Document Upload
            <small>Upload supporting documents</small>
          </v-stepper-step>
          <v-stepper-content step="4">
            <v-row wrap>
              <v-col col="12">
                <multi-file-upload
                  :customer="null"
                  :referral="SelectedReferral"
                  @uploaded="fileUploaded"
                ></multi-file-upload>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <uploaded-files
                  @remove="fileRemove"
                  v-if="updates.documents.length > 0"
                  :documents="updates.documents"
                ></uploaded-files>
              </v-col>
            </v-row>
            <v-btn color="accent" @click.native="prepareDetailsAndRegister">{{ formAction }}e</v-btn>
          </v-stepper-content>

          <v-stepper-step step="5" :complete="step > 5" :rules="[() => registrationSuccess !== false]" editable>
            {{ formAction }}e
            <small v-if="registrationSuccess === false"
              >There was a problem {{ lowerCase(formAction) }}ing the referral</small
            >
            <small v-else>{{ formAction }}e the referral</small>
          </v-stepper-step>
          <v-stepper-content step="5">
            <v-alert type="success" :value="registrationSuccess">
              Referral has been successfully {{ lowerCase(formAction) }}ed
            </v-alert>
            <v-alert type="error" :value="!registrationSuccess">
              There was a problem {{ lowerCase(formAction) }}ing the referral
            </v-alert>
            <v-btn color="accent" @click.native="closeDialog">Finish</v-btn>
          </v-stepper-content>
        </v-stepper>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import MultiFileUpload from './MultiFileUpload';
import UploadedFiles from './UploadedFiles';
import { emailRules } from '@/utils/validators';
import userApi from '@/api/user';

export default {
  name: 'referral-edit-dialog',
  components: { MultiFileUpload, UploadedFiles },
  props: {
    show: { type: Boolean, default: false },
    referralDetails: Object,
    manualImport: { type: Boolean, default: false }
  },
  data: () => ({
    step: 1,
    pickers: {
      required_by: false,
      requested_on: false
    },
    date: null,
    updates: {
      id: null,
      company_name: null,
      legal_status: null,
      months_of_revenue: null,
      title: null,
      first_name: null,
      last_name: null,
      email: null,
      phone: null,
      address_1: null,
      address_2: null,
      address_3: null,
      address_4: null,
      address_5: null,
      post_code: null,
      requested_amount: null,
      finance_type_requested: null,
      required_by: null,
      requested_on: null,
      bank_reference: null,
      business_id: null,
      creator_id: null,
      import_id: null,
      documents: []
    },
    legalStatuses: [
      { id: 'limited_company', name: 'Limited Company' },
      { id: 'limited_partnership', name: 'Limited Partnership' },
      { id: 'partnership_less_than_equal_to_3', name: 'Partnership (3 or less)' },
      { id: 'partnership_greater_than_3', name: 'Partnership (more than 3)' },
      { id: 'public_company', name: 'Public Company' },
      { id: 'sole_trader', name: 'Sole Trader' },
      { id: 'charity_limited_by_guarantee', name: 'Charity Limited by Guarantee' },
      { id: 'other', name: 'Other' }
    ],
    financeTypes: [
      { id: 'term_loan', name: 'Term Loan' },
      { id: 'overdraft', name: 'Overdraft' },
      { id: 'hire_purchase_or_lease', name: 'Hire Purchase or Lease' },
      { id: 'commercial_mortgage', name: 'Commercial Mortgage' },
      { id: 'business_credit_card', name: 'Business Credit Card' },
      { id: 'factoring_or_discounting', name: 'Factoring or Discounting' },
      { id: 'other_finance', name: 'Other Finance' },
      { id: 'multiple', name: 'Multiple' }
    ],
    emailRules,
    registrationSuccess: null,
    users: []
  }),
  computed: {
    ...mapGetters(['SelectedReferral', 'RegistrationReferrerList', 'PlatformUser', 'UserBusinesses']),
    dialog: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      }
    },
    formAction: {
      get() {
        return this.isUpdate ? 'Updat' : 'Creat';
      }
    },
    businessId: {
      get() {
        return this.updates.business_id;
      },
      set(businessId) {
        this.updates.business_id = businessId;
        this.fetchReferrerUsers();
      }
    },
    isUpdate() {
      return this.isFilled(this.referralDetails) && this.manualImport === false;
    }
  },
  methods: {
    ...mapActions(['addReferral', 'updateReferral', 'getRegistrationReferrerList']),
    closeDialog() {
      this.clearReferral();
      this.dialog = false;
    },
    prepareDetailsAndRegister() {
      if (this.updates.id === null) {
        this.addReferral(this.updates)
          .then(() => {
            this.registrationSuccess = true;
            this.step = 5;
          })
          .catch(() => {
            this.registrationSuccess = false;
            this.step = 5;
          });
      } else {
        this.updateReferral({
          id: this.updates.id,
          updates: this.updates
        })
          .then(() => {
            this.registrationSuccess = true;
            this.step = 5;
          })
          .catch(() => {
            this.registrationSuccess = false;
            this.step = 5;
          });
      }
    },
    lowerCase: function(str) {
      return _.lowerCase(str);
    },
    isDefined: function(value) {
      return _.isUndefined(value) === false;
    },
    isFilled: function(value) {
      return !_.isEmpty(value);
    },
    fileRemove(index) {
      this.updates.documents.splice(index, 1);
    },
    fileUploaded(url) {
      this.updates.documents.push(url);
    },
    clearReferral() {
      this.updates = {
        id: null,
        company_name: null,
        legal_status: null,
        months_of_revenue: null,
        title: null,
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        address_1: null,
        address_2: null,
        address_3: null,
        address_4: null,
        address_5: null,
        post_code: null,
        requested_amount: null,
        finance_type_requested: null,
        required_by: null,
        requested_on: null,
        bank_reference: null,
        business_id: null,
        creator_id: null,
        import_id: null,
        documents: []
      };
    },
    fetchReferrerUsers() {
      userApi
        .getUsersByBusiness({ businessId: this.updates.business_id })
        // eslint-disable-next-line no-return-assign
        .then(users => (this.users = users));
    }
  },
  watch: {
    show: function() {
      this.clearReferral();
      this.step = 1;
      if (!_.isEmpty(this.referralDetails)) {
        _.merge(this.updates, _.pick(this.referralDetails, Object.keys(this.updates)));
        if (!_.isUndefined(this.referralDetails.address)) {
          this.updates.address_1 = this.referralDetails.address.line_1;
          this.updates.address_2 = this.referralDetails.address.line_2;
          this.updates.address_3 = this.referralDetails.address.line_3;
          this.updates.address_4 = this.referralDetails.address.line_4;
          this.updates.address_5 = this.referralDetails.address.line_5;
          this.updates.post_code = this.referralDetails.address.post_code;
        }
        this.updates.business_id = _.isUndefined(this.referralDetails.referrer.id)
          ? this.UserBusinesses[0]
          : this.referralDetails.referrer.id;
        if (!_.isUndefined(this.referralDetails.import_id)) {
          this.updates.import_id = this.referralDetails.import_id;
        }
      }
      if (this.RegistrationReferrerList.length === 0) {
        this.getRegistrationReferrerList();
      }
      if (this.updates.business_id) {
        this.fetchReferrerUsers();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  div.list__tile,
  .subheader {
    padding: 0 16px 0 0;
  }

  input,
  label {
    font-size: 14px;
  }
}

address {
  font-style: normal;
}
</style>
